import React from 'react';

const Housing = () => {
  return <div className="housing-page"><h1>Housing Solutions</h1></div>;
};

export default Housing;